import type { SVGProps } from 'react';
const SvgStarSplash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89 81" {...props}>
    <g fill="none">
      <path
        fill="#CBD5E0"
        d="M87.85 27.264c5.133 12.983-7.619 34.383-24.374 45.243-16.77 10.844-37.545 11.147-49.974 1.805C1.072 64.969-3.011 45.98 2.235 32.853 7.48 19.71 22.057 12.411 40.878 11.054 59.683 9.697 82.7 14.28 87.85 27.264"
      />
      <path
        fill="#1A202C"
        d="m76.772 22.004-18.949-2.732-8.47-16.987c-1.517-3.027-5.914-3.066-7.444 0l-8.47 16.987-18.949 2.732c-3.398.488-4.76 4.632-2.295 7.005l13.709 13.215-3.243 18.667c-.583 3.374 3.01 5.902 6.019 4.324L45.63 56.4l16.952 8.814c3.01 1.565 6.602-.95 6.018-4.324l-3.24-18.666 13.71-13.215c2.463-2.373 1.102-6.517-2.297-7.005zM58.68 40.07l3.074 17.756-16.122-8.378-16.121 8.378 3.073-17.756-13.047-12.573 18.028-2.592L45.632 8.74 53.7 24.904l18.028 2.592z"
      />
    </g>
  </svg>
);
export default SvgStarSplash;
